module.exports = __webpack_public_path__ + "img/interpackmaxi-badge.2ec426c1.svg";